var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFactCounter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_36904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6317 29.6599C23.3242 29.6599 29.5603 23.4238 29.5603 15.7313C29.5603 8.03877 23.3242 1.80273 15.6317 1.80273C7.93916 1.80273 1.70312 8.03877 1.70312 15.7313C1.70312 23.4238 7.93916 29.6599 15.6317 29.6599Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.70312 15.7314H29.5603",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9887 15.7313C20.7256 20.8249 18.8494 25.7028 15.6316 29.6599C12.4137 25.7028 10.5376 20.8249 10.2744 15.7313C10.5376 10.6378 12.4137 5.75985 15.6316 1.80273C18.8494 5.75985 20.7256 10.6378 20.9887 15.7313V15.7313Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_36904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.631836 0.731445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFactCounter3);
export default __webpack_public_path__ + "static/media/icon-fact-counter-3.2381f03a57cd86a2b1f9671cbc9648a5.svg";
export { ForwardRef as ReactComponent };